<template>
  <div class="container">
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
            Φίλτρα αναζήτησης
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="documentIssueDateStartFilter"
                          label="Ημερομηνία έκδοσης (Από)"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable>
                      </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="documentIssueDateStartFilter"
                      @input="menu1 = false">
                  </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="documentIssueDateStopFilter"
                            label="Ημερομηνία έκδοσης (Έως)"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="documentIssueDateStopFilter"
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
                <v-select 
                    v-bind:items="documentTypes" 
                    v-model="documentTypeFilter"
                    return-object
                    
                    item-text="description" 
                    label="Είδος παραστατικού"
                    clearable>
                </v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete 
                    v-bind:items="customers" 
                    v-model="selectedCustomer"
                    return-object
                    
                    item-text="name" 
                    label="Προμηθευτής"
                    clearable>
                </v-autocomplete>
            </v-col>
        </v-row>

                    <v-row class="my-3" cols="12" align="center" justify="center">
            <v-btn 
                color="success" 
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="getData" 
                :loading="getDataButtonDisabled"
            >
                <v-icon left size="20">mdi-magnify</v-icon>
                <span>ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                color="orange darken-2" 
                dark
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="clearFilters" 
            >
                <v-icon left size="20">mdi-broom</v-icon>
                <span>ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>
          </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Φόρτωση αποδείξεων πληρωμής..."
      no-data-text="Δεν υπάρχουν δεδομένα"
      :sort-by="['issue_date']"
      :sort-desc="true"
      class="elevation-1"
      disable-pagination
      disable-filtering
      hide-default-footer>
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Πληρωμές</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div>Σύνολο: {{ listItemsSum.toFixed(2) }}</div>
          <v-spacer></v-spacer>
          
          <v-btn 
            color="primary" 
            rounded 
            elevation="2" 
            class="m-2 px-4 font-weight-bold white--text" 
            @click="newDocumentButtonClicked"
          >
            <v-icon left size="20">mdi-plus</v-icon>
            <span>ΝΕΟ</span>
          </v-btn>
          <table-export-menu
            title="Πληρωμές"
            :headers="headers"
            :items="items"
            :visible="showExport"
            button-class="m-2"
          />

          
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής {{editedItem.full_document_name}};</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogMail" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Αποστολή email</v-card-title>
              <v-card-text>
                <v-text-field 
                  v-model="editedItem.customer_email"
                  label="Διεύθυνση αποστολής"
                  hint="Για πολλαπλά email διαχωρίστε με ; (π.χ. email1@test.gr; email2@test.gr)"
                  persistent-hint>
                </v-text-field>
                <v-checkbox v-model="saveMailAddress" label="Αποθήκευση διεύθυνσης email"/>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeMail">ΑΚΥΡΟ</v-btn>
                <v-btn color="success darken-1" @click="mailConfirm" v-bind:loading="mailButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-toolbar>
      </template>
      
      <template v-slot:[`item.issue_date`]="{ item }">
        {{ formatDate(item.issue_date) }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small color="primary" @click="sendMail(item)"> mdi-email </v-icon>
        <v-icon small color="primary" @click="show(item)"> mdi-printer </v-icon>
        <v-icon small color="error" @click="deleteItem(item)"> mdi-delete </v-icon>
        <!--
        <router-link :to="{name: 'editservicedocument', params: {id: item.id}}"> 	
        <v-icon small class="mr-2"> mdi-pencil </v-icon>
        </router-link>
        
        -->

      </template>
    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({
      loading: true,

      menu1: null,
      menu2: null,
      documentTypes: [],

      saveMailAddress: false,

      customers: [],
      selectedCustomer: null,
      

      documentTypeFilter: null,
      documentIssueDateStartFilter: null,
      documentIssueDateStopFilter: null,


      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,


      editedItem: {},
      dialog: false,
      dialogDelete: false,
      dialogMail: false,
      saveMailAddress: false,


      deleteButtonDisabled: false,
      mailButtonDisabled: false,

      headers: [
        { 
            text: 'Actions',
            align: 'center', 
            value: 'actions', 
            sortable: false,
            exportable: false
        },
        {
          text: 'Ημερομηνία',
          align: 'start',
          value: 'issue_date',
          exportTransformer: (cell) => moment(cell).format("DD/MM/YYYY")
        },
        { 
          text: 'Παραστατικό', 
          align: 'center',
          value: 'full_document_name' 
        },
        {
          text: 'Προμηθευτής',
          align: 'center',
          value: 'customer_name',
        },
        {
          text: 'ΑΦΜ',
          align: 'center',
          value: 'customer_tax_registration_number',
        },
        { 
          text: 'Μικτό', 
          align: 'center',
          value: 'gross_value',
          exportTransformer: (cell) => cell.replace('.', ',')  
        },
        { 
          text: 'Τρόπος πληρωμής', 
          align: 'center',
          value: 'payment_type' 
        },
        
        
      ],

      items: [],


    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    computed: {
      showExport() {
        return this.items?.length > 0
      },

      showListItemsSum() {
        return this.listItemsSum > 0 ? true : false
      },

      listItemsSum() {
        if (this.items?.length > 0 == false)
          return 0
        
        const sum = this.items?.map(x => parseFloat(x.gross_value)).reduce((a, b) => a + b, 0)


        return sum

      },
    },

    methods: {

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xlsx')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      newDocumentButtonClicked() {
        this.$router.push({ name: 'newpaymentdocument' })
      },

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      mixmatch(customer) {
        customer.country = this.countries.find(country => country.id == customer.country_id)
        customer.taxOffice = this.taxOffices.find(taxOffice => taxOffice.id == customer.tax_registration_office_id )
        
        return customer
      },

      initialize () {
        this.$store.dispatch('currentUser/getCurrentUser')
        
        const initialDaysBeforeFilterValue = 30

        const today = new Date();

        let filterStart = new Date()
        filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

        this.documentIssueDateStartFilter = this.$localDateString(filterStart)
        // this.documentIssueDateStopFilter = today.toISOString().split('T')[0]

        this.getData()
        this.getFilterValues()
      },

      getFilterValues() {
        axios.get('/api/document-types/payment')
        .then(response => this.documentTypes = response.data)

        axios.get('/api/accounts')
        .then(response => this.customers = response.data)
      },

      getRequestParams() {
          return {
              issue_date_start: this.documentIssueDateStartFilter,
              issue_date_stop: this.documentIssueDateStopFilter,
              document_type_id: this.documentTypeFilter?.id ?? null,
              supplier_id: this.selectedCustomer?.id ?? null
          }

      },

      getData() {
        this.loading = true;
          this.getDataButtonDisabled = true;
          axios.get(
              '/api/documents/payment/grid', 
              {
                  params: this.getRequestParams()
              }
          ).then(response => this.items = response.data)
          .finally(() => {
          this.getDataButtonDisabled = false;
          this.loading = false;
        })
      },
      clearFilters() {
        this.selectedCustomer = null
        this.documentIssueDateStartFilter = null
        this.documentIssueDateStopFilter = null
        this.documentTypeFilter = null
      },

      editItem (item) {
        // this.editedIndex = this.items.indexOf(item)
        // this.editedItem = Object.assign({}, item)
        // this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true
        axios.delete(`/api/documents/payment/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },


      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      mailConfirm() {
        this.mailButtonDisabled = true
        axios
          .post('/api/mailer/payment', { 
            document_id: this.editedItem.id, 
            email_address: this.editedItem.customer_email, 
            save_email: this.saveMailAddress ? true : false 
          })
          .then(response => { 
            console.log(response); 
            if (this.saveMailAddress && this.editedIndex > -1) {
              this.items[this.editedIndex].customer_email = this.editedItem.customer_email;
            }
            this.closeMail(); 
          })
          .catch(error => { 
            console.log(error);
            let msg = 'Σφάλμα κατά την αποστολή του email.';
            if (error.response && error.response.data && error.response.data.message) {
              msg = error.response.data.message;
            }
            if (this.$swal) {
              this.$swal.fire('Σφάλμα', msg, 'error');
            }
          })
          .finally(() => { this.mailButtonDisabled = false })
      },

      sendMail(item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogMail = true
      },

      show(item) {
        window.open(`/paymentreceipts/pdf/${item.uuid}`, '_blank').focus();
      },


      closeMail() {
        this.editedItem = {};
        this.editedIndex = -1;
        this.saveMailAddress = false;
        this.dialogMail = false;
      }
    }
  }
</script>

<style scoped>
</style>